









import {Vue, Component, Prop, Emit, Model, Watch} from 'vue-property-decorator';

@Component({
  name: 'MyNavs',
})
export default class MyNavs extends Vue {
  @Prop() routeObj: object;
  @Prop({
    default: 'row'
  })
  direction: string;
  get routeAddress(): string {
    return this.$route.path;
  };

  @Model('change')
  navActive: string

  @Emit('change')
  emitChange(newValue: any): void {
  }

  @Watch('routeAddress') // 监听地址栏是否变化
  onChangeRouteAddress(newValue) {
    console.log(newValue);
    for( const key in this.routeObj ) {
      console.log(this.routeObj[key]);
      if(this.routeObj[key] === newValue) {
        this.emitChangeNav(key);
      }
    }
  }

  get navTitleArr(): Array<string> {
    return Object.keys(this.routeObj);
  };

  changeNav(item) {
    this.emitChangeNav(item);
    this.$router.push(this.routeObj[item]);
  }

  @Emit('change')
  emitChangeNav(newValue: any): void {
  }
}
